<template>
  <div class="fccSirs">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actionsSir"
            addFilter
            :items="listagemSubTipoSir2Monit"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldSubTipo"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            tipoSir.id === 0 ? adicionarSubTipoSir2Monit() : editarSubTipoSir2Monit()
          "
        >
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="tipoSir.descricao"
                >Subtipo</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import Sirs from './mixim/sirs'
Vue.mixin(Sirs)

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Subtipo de SIR',
      titlePDF: 'Lista de Subtipo de SIR',
      titleModal: '',
      fields: [
        { key: 'id', label: 'Id', sortable: false },
        { key: 'descricao', label: 'Tipo', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      tipoSir: {},
      actionsSir: [
        {
          button: true,
          funcaoButton: 'editSubTipoSir2Monit',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteSubTipoSir2Monit',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    deleteSubTipoSir2Monit: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.descricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSir2 + 'SubTipoSir2Monit/Excluir/id?id=' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarSubTipoSir2Monit()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    addField() {
      this.tipoSir = {}
      this.tipoSir.id = 0
      this.titleModal = 'Adicionar tipo de SIR'
      this.$root.$emit('bv::show::modal', 'addFieldSubTipo')
    },
    editarSubTipoSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSir2 + 'SubTipoSir2Monit/Alterar',
          this.tipoSir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarSubTipoSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldSubTipo')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionarSubTipoSir2Monit() {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSir2 + 'SubTipoSir2Monit/Adicionar',
          this.tipoSir,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarSubTipoSir2Monit()
          this.$root.$emit('bv::hide::modal', 'addFieldSubTipo')
          this.callToast(this.mensagensUpdate.adicionado, 'success')
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    editSubTipoSir2Monit: function (_, item) {
      this.tipoSir = { ...item }
      this.titleModal = 'Editar tipo de SIR'
      this.$root.$emit('bv::show::modal', 'addFieldSubTipo')
    }
  },
  mounted: function () {
    this.listarSubTipoSir2Monit()
  }
}
</script>
